import { apiClient } from "../apiClient";

export const QUY_CHE_ENDPOINT = "quy-che";
export const quyCheApi = {
    SelectAll: () => apiClient.get(`${QUY_CHE_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(QUY_CHE_ENDPOINT, payload),
    Update: (id: number, payload: any) => apiClient.put(`${QUY_CHE_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${QUY_CHE_ENDPOINT}/${id}`),
}